<template>
  <div class="follow-up-reports">
    <b-container fluid>
      <h1>Additional Inscription</h1>
      <b-row>
        <b-col>
          <b-form-group label-for="filterCriteria">
            <b-input-group>
              <b-form-input
                type="text"
                id="filterCriteria"
                v-model="filterCriteria"
                class="form-control"
                placeholder="Type to search"
              ></b-form-input>
              <b-input-group-append>
                <b-button @click="cleanFilterInfo()" variant="primary"
                  ><b-icon icon="x-circle" variant="white"></b-icon
                ></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-h="between">
        <b-col cols="3">
          <b-pagination
            v-model="currentPage"
            :page="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </b-col>
        <b-col cols="8">
          <b-row align-h="end">
            <b-col>
              <b-form-datepicker
                today-button
                reset-button
                close-button
                v-model="time_range.start"
                placeholder="start date"
              ></b-form-datepicker>
            </b-col>
            <b-col>
              <b-form-datepicker
                today-button
                reset-button
                close-button
                v-model="time_range.end"
                placeholder="end date"
              ></b-form-datepicker>
            </b-col>
            <b-col>
              <b-button-group>
                <b-button variant="primary" @click="submitTimeRange()"
                  >Submit</b-button
                >
                <b-button variant="secondary" @click="resetTimeRange()"
                  >Reset</b-button
                >
              </b-button-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <b-button variant="primary" @click="showModal('modal-add-report')"
        >Add</b-button
      >
      <b-button
        v-if="this.user.name=='Rick'"
        class="ml-2 mb-2"
        variant="primary"
        @click="testFunction()"
        >Test Function</b-button
      >

      <b-table
        class="pointer mt-2"
        id="my-table"
        responsive
        striped
        bordered
        :fields="report_fields"
        :filter="filterCriteria"
        :items="displayed_reports"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        small
      >
        <template #cell(invoice_number)="row">
          <div
            class="table-button"
            @click="myRowClickHandler(Object.assign({}, row.item))"
          >
            {{ row.item.invoice_number }}
          </div>
        </template>

        <template #cell(follower)="row">
          <div
            class="table-button"
            @click="follower_clicked(Object.assign({}, row.item))"
          >
            {{ row.item.follower }}
          </div>
        </template>

        <template #cell(worker_name)="row">
          <div
            class="table-button"
            @click="worker_name_clicked(Object.assign({}, row.item))"
          >
            {{ row.item.worker_name }}
          </div>
        </template>

        <template #cell(order_date)="row">
          <div
            class="table-button"
            @click="contract_signed_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.order_date) }}
          </div>
        </template>

        <template #cell(contract_due_date)="row">
          <div
            class="table-button"
            @click="contract_due_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.contract_due_date) }}
          </div>
        </template>

        <template #cell(proof_request_date)="row">
          <div
            v-if="
              !row.item.proof_request_date_not_required ||
                row.item.proof_request_date_not_required == 'false'
            "
            class="table-button"
            @click="proof_request_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.proof_request_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.proof_request_date_comment != null &&
                  row.item.proof_request_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.proof_request_date_not_required == 'true'"
            class="table-button"
            @click="proof_request_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.proof_request_date_comment != null &&
                  row.item.proof_request_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(proof_signed_date)="row">
          <div
            v-if="
              !row.item.proof_signed_date_not_required ||
                row.item.proof_signed_date_not_required == 'false'
            "
            class="table-button"
            @click="proof_signed_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.proof_signed_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.proof_signed_date_comment != null &&
                  row.item.proof_signed_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.proof_signed_date_not_required == 'true'"
            class="table-button"
            @click="proof_signed_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.proof_signed_date_comment != null &&
                  row.item.proof_signed_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(permit_sent_date)="row">
          <div
            v-if="
              !row.item.permit_sent_date_not_required ||
                row.item.permit_sent_date_not_required == 'false'
            "
            class="table-button"
            @click="permit_sent_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.permit_sent_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.permit_sent_date_comment != null &&
                  row.item.permit_sent_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.permit_sent_date_not_required == 'true'"
            class="table-button"
            @click="permit_sent_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.permit_sent_date_comment != null &&
                  row.item.permit_sent_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(permit_received_date)="row">
          <div
            v-if="
              !row.item.permit_received_date_not_required ||
                row.item.permit_received_date_not_required == 'false'
            "
            class="table-button"
            @click="permit_received_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.permit_received_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.permit_received_date_comment != null &&
                  row.item.permit_received_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.permit_received_date_not_required == 'true'"
            class="table-button"
            @click="permit_received_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.permit_received_date_comment != null &&
                  row.item.permit_received_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(accessory_ordered_date)="row">
          <div
            v-if="
              !row.item.accessory_ordered_date_not_required ||
                row.item.accessory_ordered_date_not_required == 'false'
            "
            class="table-button"
            @click="accessory_ordered_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.accessory_ordered_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.accessory_ordered_date_comment != null &&
                  row.item.accessory_ordered_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.accessory_ordered_date_not_required == 'true'"
            class="table-button"
            @click="accessory_ordered_date_clicked(Object.assign({}, row.item))"
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.accessory_ordered_date_comment != null &&
                  row.item.accessory_ordered_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(accessory_received_date)="row">
          <div
            v-if="
              !row.item.accessory_received_date_not_required ||
                row.item.accessory_received_date_not_required == 'false'
            "
            class="table-button"
            @click="
              accessory_received_date_clicked(Object.assign({}, row.item))
            "
          >
            {{ formatDate(row.item.accessory_received_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.accessory_received_date_comment != null &&
                  row.item.accessory_received_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
          <div
            v-if="row.item.accessory_received_date_not_required == 'true'"
            class="table-button"
            @click="
              accessory_received_date_clicked(Object.assign({}, row.item))
            "
          >
            N/R
            <b-icon
              class="ml-1"
              v-if="
                row.item.accessory_received_date_comment != null &&
                  row.item.accessory_received_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(order_sent_date)="row">
          <div
            class="table-button"
            @click="order_sent_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.order_sent_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.order_sent_date_comment != null &&
                  row.item.order_sent_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(job_complete_date)="row">
          <div
            class="table-button"
            @click="job_complete_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.job_complete_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.job_complete_date_comment != null &&
                  row.item.job_complete_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>

        <template #cell(accessory_complete_date)="row">
          <div
            class="table-button"
            @click="accessory_complete_date_clicked(Object.assign({}, row.item))"
          >
            {{ formatDate(row.item.accessory_complete_date) }}
            <b-icon
              class="ml-1"
              v-if="
                row.item.accessory_complete_date_comment != null &&
                  row.item.accessory_complete_date_comment.length > 0
              "
              icon="card-text"
              scale="1.0"
              variant="primary"
            ></b-icon>
          </div>
        </template>
      </b-table>
    </b-container>

    <!-- DELETE REPORT -->
    <b-modal id="modal-delete-report" title="Delete confirmation" hide-footer>
      <p>This operation will delete a report.</p>
      <div class="modal-footer mt-1">
        <b-button variant="secondary" @click="hideModal('modal-delete-report')">
          Cancel
        </b-button>
        <b-button
          :disabled="isDeleting"
          variant="danger"
          @click="delete_report_task()"
        >
          <span v-if="!isDeleting">Delete</span>
          <span v-if="isDeleting">
            <b-spinner small type="grow"></b-spinner>
            Deleting...
          </span>
        </b-button>
      </div>
    </b-modal>

    <!-- ADD REPORT -->
    <b-modal id="modal-add-report" hide-footer title="Add report">
      <b-form @submit.prevent="add_report">
        <label for="invoice_number">Invoice No.:</label>
        <b-input
          type="text"
          id="invoice_number"
          v-model="new_report.invoice_number"
          required
        ></b-input>

        <label for="customer_name">Customer Name.:</label>
        <b-input
          type="text"
          id="customer_name"
          v-model="new_report.customer_name"
          required
        ></b-input>

        <label for="order_date">Contract Signed Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="order_date"
          v-model="new_report.order_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="proof_request_date">Proof Request Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="proof_request_date"
          v-model="new_report.proof_request_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="proof_signed_date">Proof Signed Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="proof_signed_date"
          v-model="new_report.proof_signed_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="permit_sent_date">Permit Sent Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="permit_sent_date"
          v-model="new_report.permit_sent_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="permit_received_date">Permit Received Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="permit_received_date"
          v-model="new_report.permit_received_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="accessory_ordered_date">Accessory Ordered Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="accessory_ordered_date"
          v-model="new_report.accessory_ordered_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="accessory_received_date">Accessory Received Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="accessory_received_date"
          v-model="new_report.accessory_received_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="job_complete_date">Accessory Complete Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="job_complete_date"
          v-model="new_report.accessory_complete_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="job_complete_date">Inscription Complete Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="job_complete_date"
          v-model="new_report.job_complete_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="cemetery">Cemetery:</label>
        <b-form-select
          id="cemetery"
          v-model="new_report.cemetery"
          :options="cemeterys"
          required
        ></b-form-select>

        <label for="follower">Who is following:</label>
        <!-- <p v-if="this.user.role == 'sales'">{{this.user.name}}</p> -->
        <b-form-select
          id="follower"
          v-model="new_report.follower"
          :options="sales_names"
          required
        ></b-form-select>

        <label for="description">Description:</label>
        <b-textarea
          type="text"
          id="description"
          v-model="new_report.description"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-add-report')"> Cancel </b-button>
          <b-button :disabled="isSubmitting" type="submit" variant="primary">
            <span v-if="!isSubmitting">Submit</span>
            <span v-if="isSubmitting">
              <b-spinner small type="grow"></b-spinner>
              Submitting...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- VIEW REPORT -->
    <b-modal size="lg" id="modal-view-report" hide-footer title="View report">
      <b-form>
        <label for="invoice_number">Invoice No.:</label>
        <b-input
          type="text"
          id="invoice_number"
          v-model="viewed_report.invoice_number"
          required
        ></b-input>

        <label for="customer_name">Customer Name.:</label>
        <b-input
          type="text"
          id="customer_name"
          v-model="viewed_report.customer_name"
          required
        ></b-input>

        <label for="order_date">Contract Signed Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="order_date"
          v-model="viewed_report.order_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="proof_request_date">Proof Request Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="proof_request_date"
          v-model="viewed_report.proof_request_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="proof_signed_date">Proof Signed Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="proof_signed_date"
          v-model="viewed_report.proof_signed_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="permit_sent_date">Permit Sent Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="permit_sent_date"
          v-model="viewed_report.permit_sent_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="permit_received_date">Permit Received Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="permit_received_date"
          v-model="viewed_report.permit_received_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="accessory_ordered_date">Accessory Ordered Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="accessory_ordered_date"
          v-model="viewed_report.accessory_ordered_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="accessory_received_date">Accessory Received Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="accessory_received_date"
          v-model="viewed_report.accessory_received_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="job_complete_date">Job Complete Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="date"
          id="job_complete_date"
          v-model="viewed_report.job_complete_date"
          class="form-control"
        ></b-form-datepicker>

        <label for="cemetery">Cemetery:</label>
        <b-form-select
          id="cemetery"
          v-model="viewed_report.cemetery"
          :options="cemeterys"
          required
        ></b-form-select>

        <label for="follower">Who is following:</label>
        <!-- <p v-if="this.user.role == 'sales'">{{this.user.name}}</p> -->
        <b-form-select
          id="follower"
          v-model="viewed_report.follower"
          :options="sales_names"
          required
        ></b-form-select>

        <label for="created_by">Created by:</label>
        <p>{{ viewed_report.created_by.name }}</p>

        <label for="description">Description:</label>
        <b-textarea
          type="text"
          id="description"
          v-model="viewed_report.description"
        ></b-textarea>

        <div class="modal-footer">
          <b-button variant="danger" @click="delete_report(viewed_report.id)"
            >Delete</b-button
          >
          <b-button @click="showModal('modal-edit-histories')"
            >Edit Histories</b-button
          >
          <b-button @click="hideModal('modal-view-report')"> Return </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- Edit Histories -->
    <b-modal id="modal-edit-histories" hide-footer title="Edit Histories">
      <div
        v-for="(history, index) in this.viewed_report.edit_histories"
        :key="'history' + index"
      >
        <b-row align-v="center" v-b-toggle="'accordion-history' + index">
          <b-col cols="5">
            <strong>{{ history.edit_on }}.{{ history.edit_by }}</strong>
          </b-col>
          <b-col cols="6">
            <hr />
          </b-col>
          <b-col>
            <b-row>
              <b-icon
                icon="chevron-down"
                scale="1"
                variant="secondary"
              ></b-icon>
            </b-row>
          </b-col>
        </b-row>
        <b-collapse
          v-bind:id="'accordion-history' + index"
          role="tabpanel"
          class="mx-3"
        >
          <label v-if="history.invoice_number.length > 0">Invoice No.:</label>
          <p>{{ history.invoice_number }}</p>

          <label for="customer_name">Customer Name.:</label>
          <p>{{ history.customer_name }}</p>

          <label for="order_date">Order Placed Date:</label>
          <p>{{ history.order_date }}</p>

          <label for="proof_request_date">Proof Request Date:</label>
          <p>{{ history.proof_request_date }}</p>

          <label for="proof_signed_date">Proof Signed Date:</label>
          <p>{{ history.proof_signed_date }}</p>

          <label for="permit_sent_date">Permit Sent Date:</label>
          <p>{{ history.permit_sent_date }}</p>

          <label for="accessory_ordered_date">Accessory Ordered Date:</label>
          <p>{{ history.accessory_ordered_date }}</p>

          <label for="job_complete_date">Job Complete Date:</label>
          <p>{{ history.job_complete_date }}</p>

          <label for="cemetery">Cemetery:</label>
          <p>{{ history.cemetery }}</p>

          <label for="follower">Who is following:</label>
          <p>{{ history.follower }}</p>

          <label for="created_by">Created By:</label>
          <p>{{ history.created_by.name }}</p>

          <label for="description">Description:</label>
          <b-textarea
            type="text"
            id="description"
            v-model="viewed_report.description"
          ></b-textarea>
        </b-collapse>
      </div>
    </b-modal>

    <!-- EDIT COLUMNS -->
    <b-modal id="modal-edit-follower" hide-footer title="Sales">
      <b-form @submit.prevent="edit_follower">
        <label for="follower">Who is following:</label>
        <b-form-select
          id="follower"
          v-model="viewed_report.follower"
          :options="sales_names"
          required
        ></b-form-select>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-follower')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-worker-name" hide-footer title="Worker">
      <b-form @submit.prevent="edit_worker_name">
        <label for="worker_name">Worker:</label>
        <b-form-select
          id="worker_name"
          v-model="viewed_report.worker_name"
          :options="worker_names"
          required
        ></b-form-select>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-worker-name')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-contract-signed"
      hide-footer
      title="Contract Signed Date"
    >
      <b-form>
        <label for="report_contract_signed">Contract Signed Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_contract_signed"
          v-model="viewed_report.order_date"
        ></b-form-datepicker>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-contract-signed')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-contract-due" hide-footer title="Contract Due Date">
      <b-form>
        <label for="report_contract_due">Contract Due Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_contract_due"
          v-model="viewed_report.contract_due_date"
        ></b-form-datepicker>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-contract-due')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-proof-request"
      hide-footer
      title="Proof Request Date"
    >
      <b-form>
        <label for="report_proof_request">Proof Request Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="request_plan_not_required"
          v-model="viewed_report.proof_request_date_not_required"
          name="proof_request_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_proof_request"
          v-model="viewed_report.proof_request_date"
        ></b-form-datepicker>
        <label for="request_plan_date_description">Comment:</label>
        <b-textarea
          type="text"
          id="request_plan_date_description"
          v-model="viewed_report.proof_request_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-proof-request')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-proof-signed" hide-footer title="Proof Signed Date">
      <b-form>
        <label for="report_proof_signed">Proof Signed Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="proof_signed_date_not_required"
          v-model="viewed_report.proof_signed_date_not_required"
          name="proof_signed_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_proof_signed"
          v-model="viewed_report.proof_signed_date"
        ></b-form-datepicker>
        <label for="proof_signed_date_description">Comment:</label>
        <b-textarea
          type="text"
          id="proof_signed_date_description"
          v-model="viewed_report.proof_signed_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-proof-signed')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-permit-sent" hide-footer title="Permit Sent Date">
      <b-form>
        <label for="report_permit_sent">Permit Sent Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="permit_sent_date_not_required"
          v-model="viewed_report.permit_sent_date_not_required"
          name="permit_sent_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_permit_sent"
          v-model="viewed_report.permit_sent_date"
        ></b-form-datepicker>
        <label for="permit_sent_date_description">Comment:</label>
        <b-textarea
          type="text"
          id="permit_sent_date_description"
          v-model="viewed_report.permit_sent_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-permit-sent')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-permit-received"
      hide-footer
      title="Permit Received Date"
    >
      <b-form>
        <label for="report_permit_received">Permit Sent Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="permit_received_date_not_required"
          v-model="viewed_report.permit_received_date_not_required"
          name="permit_received_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_permit_received"
          v-model="viewed_report.permit_received_date"
        ></b-form-datepicker>
        <label for="permit_received_date_description">Comment:</label>
        <b-textarea
          type="text"
          id="permit_received_date_description"
          v-model="viewed_report.permit_received_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-permit-received')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-accessory-ordered"
      hide-footer
      title="Accessory Ordered Date"
    >
      <b-form>
        <label for="report_accessory_ordered">Accessory Ordered Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="accessory_ordered_date_not_required"
          v-model="viewed_report.accessory_ordered_date_not_required"
          name="accessory_ordered_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_accessory_ordered"
          v-model="viewed_report.accessory_ordered_date"
        ></b-form-datepicker>
        <label for="accessory_ordered_date_description">Comment:</label>
        <b-textarea
          type="text"
          id="accessory_ordered_date_description"
          v-model="viewed_report.accessory_ordered_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-accessory-ordered')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="modal-edit-accessory-received"
      hide-footer
      title="Accessory Received Date"
    >
      <b-form>
        <label for="report_accessory_received">Accessory Received Date:</label>
        <b-form-checkbox
          class="ml-2"
          inline
          id="accessory_received_date_not_required"
          v-model="viewed_report.accessory_received_date_not_required"
          name="accessory_received_date_not_required"
          value="true"
          unchecked-value="false"
          >Not Required</b-form-checkbox
        >
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_accessory_received"
          v-model="viewed_report.accessory_received_date"
        ></b-form-datepicker>
        <label for="accessory_received_date_description">Comment:</label>
        <b-textarea
          type="text"
          id="accessory_received_date_description"
          v-model="viewed_report.accessory_received_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-accessory-received')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-order-sent" hide-footer title="Order Sent Date">
      <b-form>
        <label for="report_order_sent">Order Sent Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_order_sent"
          v-model="viewed_report.order_sent_date"
        ></b-form-datepicker>
        <label for="order_sent_date_description">Comment:</label>
        <b-textarea
          type="text"
          id="order_sent_date_description"
          v-model="viewed_report.order_sent_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-order-sent')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-job-complete" hide-footer title="Job Complete Date">
      <b-form>
        <label for="report_job_complete">Job Complete Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_job_complete"
          v-model="viewed_report.job_complete_date"
        ></b-form-datepicker>
        <label for="job_complete_date_description">Comment:</label>
        <b-textarea
          type="text"
          id="job_complete_date_description"
          v-model="viewed_report.job_complete_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-job-complete')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal id="modal-edit-accessory-complete" hide-footer title="Accessory Complete Date">
      <b-form>
        <label for="report_job_complete">Accessory Complete Date:</label>
        <b-form-datepicker
          today-button
          reset-button
          close-button
          type="text"
          id="report_job_complete"
          v-model="viewed_report.accessory_complete_date"
        ></b-form-datepicker>
        <label for="accessory_complete_date_description">Comment:</label>
        <b-textarea
          type="text"
          id="accessory_complete_date_description"
          v-model="viewed_report.accessory_complete_date_comment"
        ></b-textarea>

        <div class="modal-footer">
          <b-button @click="hideModal('modal-edit-accessory-complete')">
            Return
          </b-button>
          <b-button
            :disabled="isUpdating"
            variant="warning"
            @click="edit_additional_inscription_report"
          >
            <span v-if="!isUpdating">Update</span>
            <span v-if="isUpdating">
              <b-spinner small type="grow"></b-spinner>
              Updating...
            </span>
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import firebase from "firebase/app";

export default {
  computed: {
    rows: {
      get() {
        if (this.reports.length == 0) {
          return 100;
        } else {
          return this.reports.length;
        }
      },
      set(newRows) {
        return newRows;
      },
    },
  },
  created() {
    this.set_global_date();

    if (this.user.role == "sales") {
      firebase
        .firestore()
        .collection("additional_inscription_reports")
        .where("follower", "==", this.user.name)
        .orderBy("invoice_number", "asc")
        .onSnapshot((collection) => {
          this.reports = [];
          this.reports = collection.docs.map((doc) => doc.data());
          this.displayed_reports = this.reports;
        });
    } else {
      firebase
        .firestore()
        .collection("additional_inscription_reports")
        .orderBy("invoice_number", "asc")
        .onSnapshot((collection) => {
          this.reports = [];
          this.reports = collection.docs.map((doc) => doc.data());
          this.displayed_reports = this.reports;
        });
    }

    firebase
      .firestore()
      .collection("saless")
      .onSnapshot((collection) => {
        this.sales = [];
        this.sales_names = [];
        this.sales = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.sales.length; i++) {
          this.sales_names.push(this.sales[i].name);
        }
      });

    firebase
      .firestore()
      .collection("cemeteries")
      .orderBy("name")
      .onSnapshot((collection) => {
        this.cemeteries = collection.docs.map((doc) => doc.data());
        for (var i = 0; i < this.cemeteries.length; i++) {
          this.cemeterys.push(this.cemeteries[i].name);
        }

        this.cemeterys.push("others");
      });

    firebase.firestore().collection('workers').orderBy('name').onSnapshot((collection) => {
      this.workers = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.workers.length; i++) {
        this.worker_names.push(this.workers[i].name);
      }
      this.worker_names.push('Others');
      this.worker_names.push("");
    });
  },
  props: {
    user: Object,
  },
  data() {
    return {
      time_range: {
        start: "",
        end: "",
      },
      time_filtered_reports: [],
      sales: [],
      sales_names: [],
      cemeteries: [],
      cemeterys: [],
      perPage: 20,
      currentPage: 1,
      filterCriteria: "",
      tableIsBusy: false,
      deleted_report_id: "",
      report_fields: [
        { key: "invoice_number", label: "Invoice #" },
        { key: "follower", label: "Sales" },
        { key: "worker_name", label: "Worker"},
        { key: "order_date", label: "Contract Signed" },
        { key: "contract_due_date", label: "Contract Due" },
        { key: "proof_request_date", label: "Proof Request" },
        { key: "proof_signed_date", label: "Proof Signed" },
        { key: "permit_sent_date", label: "Permit Sent" },
        { key: "permit_received_date", label: "Permit Received" },
        { key: "accessory_ordered_date", label: "Accessory Ordered" },
        { key: "accessory_received_date", label: "Accessory Received" },
        { key: "order_sent_date", label: "Order Sent" },
        { key: "accessory_complete_date", label: "Accessory Complete" },
        { key: "job_complete_date", label: "Inscription Complete" },
      ],
      displayed_reports: [],
      reports: [],
      new_report: {
        created_by: "",
        created_date: "",
        id: "",
        follower: "",
        invoice_number: "",
        cemetery: "",
        customer_name: "",
        order_date: "",
        contract_due_date: "",
        proof_request_date: "",
        proof_request_date_comment: "",
        proof_request_date_not_required: "",
        proof_signed_date: "",
        proof_signed_date_comment: "",
        proof_signed_date_not_required: "",
        permit_sent_date: "",
        permit_sent_date_comment: "",
        permit_sent_date_not_required: "",
        permit_received_date: "",
        permit_received_date_comment: "",
        permit_received_date_not_required: "",
        accessory_ordered_date: "",
        accessory_ordered_date_comment: "",
        accessory_ordered_date_not_required: "",
        accessory_received_date: "",
        accessory_received_date_comment: "",
        accessory_received_date_not_required: "",
        order_sent_date: "",
        order_sent_date_comment: "",
        job_complete_date: "",
        job_complete_date_comment: "",
        accessory_complete_date: "",
        accessory_complete_date_comment: "",
        description: "",
        edit_histories: [],
        worker_name: "",
      },
      viewed_report: {
        created_by: "",
        created_date: "",
        id: "",
        follower: "",
        invoice_number: "",
        cemetery: "",
        customer_name: "",
        order_date: "",
        contract_due_date: "",
        proof_request_date: "",
        proof_signed_date: "",
        permit_sent_date: "",
        permit_received_date: "",
        accessory_ordered_date: "",
        accessory_received_date: "",
        accessory_complete_date: "",
        accessory_complete_date_comment: "",
        order_sent_date: "",
        job_complete_date: "",
        description: "",
        edit_histories: [],
        worker_name: "",
      },
      status_names: ["success", "pending", "fail"],
      isSubmitting: false,
      isUpdating: false,
      isDeleting: false,
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      workers: [],
      worker_names: [],
    };
  },
  methods: {
    myRowClickHandler(item) {
      this.viewed_report = item;
      this.showModal("modal-view-report");
      console.log(item);
    },
    delete_report(id) {
      if (this.user.role != "admin") {
        alert("You do not have authority.");
      } else {
        this.deleted_report_id = id;
        this.showModal("modal-delete-report");
      }
    },
    delete_report_task() {
      this.isDeleting = true;
      this.hideModal("modal-view-report");

      firebase
        .firestore()
        .collection("additional_inscription_reports")
        .doc(this.deleted_report_id)
        .delete()
        .then(() => {
          alert("delete successfully");
          this.isDeleting = false;
          this.hideModal("modal-delete-report");
        });
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    add_report() {
      this.isSubmitting = true;
      const new_report_ref = firebase
        .firestore()
        .collection("additional_inscription_reports")
        .doc();

      if (this.new_report.order_date != "") {
        var new_date = new Date(this.new_report.order_date);
        new_date.setDate(new_date.getDate() + 16 * 7);
        this.new_report.contract_due_date =
          new_date.getFullYear() +
          "-" +
          (new_date.getMonth() + 1) +
          "-" +
          new_date.getDate();
      }

      this.new_report.id = new_report_ref.id;
      this.new_report.created_date = this.today;
      this.new_report.created_date_timestamp = new Date(this.today);
      this.new_report.year_month = this.new_report.created_date.substring(0, 7);
      this.new_report.day = parseInt(
        this.new_report.created_date.substring(8, 10)
      );
      this.new_report.created_by = this.user;
      this.new_report.created_by_name = this.user.name;
      this.new_report.edit_histories.push({
        created_by: this.new_report.created_by,
        created_date: this.new_report.created_date,
        id: this.new_report.id,
        follower: this.new_report.follower,
        invoice_number: this.new_report.invoice_number,
        cemetery: this.new_report.cemetery,
        customer_name: this.new_report.customer_name,
        order_date: this.new_report.order_date,
        proof_request_date: this.new_report.proof_request_date,
        proof_signed_date: this.new_report.proof_signed_date,
        permit_sent_date: this.new_report.permit_sent_date,
        accessory_ordered_date: this.new_report.accessory_ordered_date,
        job_complete_date: this.new_report.job_complete_date,
        accessory_complete_date: this.new_report.accessory_complete_date,
        accessory_complete_date_comment: this.new_report.accessory_complete_date_comment,
        description: this.new_report.description,
        edit_by: this.user.name,
        edit_on: this.today,
      });

      console.log(this.new_report);

      new_report_ref.set(this.new_report).then(() => {
        this.hideModal("modal-add-report");
        const recipient = this.sales[
          this.sales_names.indexOf(this.new_report.follower)
        ];

        var email = {
          to: [recipient.email],
          message: {
            subject:
              "An additional inscription report has been allocated to you",
            text:
              "Hi " +
              recipient.name +
              ", \n" +
              "The details of the additional inscription report are as follows:\n" +
              "Created by: " +
              this.new_report.created_by_name +
              "\n" +
              "Invoice #: " +
              this.new_report.invoice_number +
              "\n",
          },
        };

        firebase
          .firestore()
          .collection("mail")
          .add(email);

        this.new_report = {
          created_by: "",
          created_date: "",
          id: "",
          sales_person: "",
          invoice_number: "",
          cemetery: "",
          customer_name: "",
          order_date: "",
          proof_request_date: "",
          proof_signed_date: "",
          permit_sent_date: "",
          accessory_ordered_date: "",
          job_complete_date: "",
          accessory_complete_date: "",
          accessory_complete_date_comment: "",
          description: "",
          edit_histories: [],
          worker_name: "",
        };

        this.isSubmitting = false;
      });
    },
    set_global_date() {
      var date_time = new Date();
      var dd = String(date_time.getDate()).padStart(2, "0");
      var mm = String(date_time.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = date_time.getFullYear();

      this.today = yyyy + "-" + mm + "-" + dd;
      this.new_report.date = this.today;
    },
    view_additional_inscription_report(additional_inscription_report) {
      this.viewed_report = additional_inscription_report;
      this.showModal("modal-view-report");
    },
    edit_additional_inscription_report() {
      this.isUpdating = true;
      this.viewed_report.edit_histories.push({
        created_by: this.viewed_report.created_by,
        created_date: this.viewed_report.created_date,
        id: this.viewed_report.id,
        follower: this.viewed_report.follower,
        invoice_number: this.viewed_report.invoice_number,
        cemetery: this.viewed_report.cemetery,
        customer_name: this.viewed_report.customer_name,
        order_date: this.viewed_report.order_date,
        proof_request_date: this.viewed_report.proof_request_date,
        proof_signed_date: this.viewed_report.proof_signed_date,
        permit_sent_date: this.viewed_report.permit_sent_date,
        accessory_ordered_date: this.viewed_report.accessory_ordered_date,
        job_complete_date: this.viewed_report.job_complete_date,
        accessory_complete_date: this.viewed_report.accessory_complete_date,
        accessory_complete_date_comment: this.viewed_report.accessory_complete_date_comment ? this.viewed_report.accessory_complete_date_comment : "",
        description: this.viewed_report.description,
        edit_by: this.user.name,
        edit_on: this.today,
      });
      console.log(this.viewed_report.edit_histories);
      firebase
        .firestore()
        .collection("additional_inscription_reports")
        .doc(this.viewed_report.id)
        .set(this.viewed_report, { merge: true })
        .then(() => {
          this.hideModal(this.modal_id);
          alert("Modify successfully");
          this.isUpdating = false;
        });
    },
    submitTimeRange() {
      var start = null;
      var end = null;

      if (this.time_range.start == "" && this.time_range.end == "") return;

      if (this.time_range.start != "") {
        start = new Date(this.time_range.start);
      }

      if (this.time_range.end != "") {
        end = new Date(this.time_range.end);
      }

      if (this.time_range.start == "" && this.time_range.end != "") {
        firebase
          .firestore()
          .collection("additional_inscription_reports")
          .where("created_date_timestamp", "<=", end)
          .orderBy("created_date_timestamp", "desc")
          .onSnapshot((collection) => {
            this.time_filtered_reports = [];
            this.time_filtered_reports = collection.docs.map((doc) =>
              doc.data()
            );
            this.displayed_reports = this.time_filtered_reports;
          });
      }

      if (this.time_range.start != "" && this.time_range.end == "") {
        console.log(start);
        firebase
          .firestore()
          .collection("additional_inscription_reports")
          .where("created_date_timestamp", ">=", start)
          .orderBy("created_date_timestamp", "desc")
          .onSnapshot((collection) => {
            this.time_filtered_reports = [];
            this.time_filtered_reports = collection.docs.map((doc) =>
              doc.data()
            );
            this.displayed_reports = this.time_filtered_reports;
          });
      }

      if (this.time_range.start != "" && this.time_range.end != "") {
        firebase
          .firestore()
          .collection("additional_inscription_reports")
          .where("created_date_timestamp", ">=", start)
          .where("created_date_timestamp", "<=", end)
          .orderBy("created_date_timestamp", "desc")
          .onSnapshot((collection) => {
            this.time_filtered_reports = [];
            this.time_filtered_reports = collection.docs.map((doc) =>
              doc.data()
            );
            this.displayed_reports = this.time_filtered_reports;
          });
      }
    },
    resetTimeRange() {
      this.displayed_reports = this.reports;
    },
    showEditHistories() {},
    cleanFilterInfo() {
      this.filterCriteria = "";
    },
    formatDate(dateString) {
      if (!dateString || dateString == "") return "";
      const ymd = dateString.split("-");
      const monthString = ymd[1].charAt(0) == "0" ? ymd[1].slice(1) : ymd[1];
      return ymd[2] + "-" + this.monthNames[parseInt(monthString) - 1];
    },
    follower_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-follower");
      this.modal_id = "modal-edit-follower";
    },
    worker_name_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-worker-name");
      this.modal_id = "modal-edit-worker-name";
    },
    contract_signed_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-contract-signed");
      this.modal_id = "modal-edit-contract-signed";
    },
    contract_due_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-contract-due");
      this.modal_id = "modal-edit-contract-due";
    },
    proof_request_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-proof-request");
      this.modal_id = "modal-edit-proof-request";
    },
    proof_signed_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-proof-signed");
      this.modal_id = "modal-edit-proof-signed";
    },
    permit_sent_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-permit-sent");
      this.modal_id = "modal-edit-permit-sent";
    },
    permit_received_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-permit-received");
      this.modal_id = "modal-edit-permit-received";
    },
    accessory_ordered_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-accessory-ordered");
      this.modal_id = "modal-edit-accessory-ordered";
    },
    accessory_received_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-accessory-received");
      this.modal_id = "modal-edit-accessory-received";
    },
    order_sent_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-order-sent");
      this.modal_id = "modal-edit-order-sent";
    },
    job_complete_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-job-complete");
      this.modal_id = "modal-edit-job-complete";
    },
    accessory_complete_date_clicked(item) {
      this.viewed_report = item;
      this.showModal("modal-edit-accessory-complete");
      this.modal_id = "modal-edit-accessory-complete";
    },
    testFunction() {
      console.log("TEST FUNCTION");
      const db = firebase.firestore();

      db.collection("additional_inscription_reports").get()
        .then((collection) => {
          var rows = collection.docs.map(doc => doc.data());
          rows.forEach((data) => {
            const follow_up_report_ref = firebase.firestore().collection("additional_inscription_reports").doc(data.id);
            follow_up_report_ref.set({accessory_complete_date: ""}, {merge: true}).then(() => {
              console.log('Test function finished.');
            });
          });
        });
    },
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.table-button {
  min-width: 65px;
  min-height: 24px;
  font-size: 14px;
}

.table-button:hover {
  color: blue;
  background-color: Gainsboro;
  text-decoration: underline;
}
</style>
